export default __webpack_public_path__ + "static/media/logo.6b374347.png";